import axios from 'axios';

import { apiRoutes } from '../config/routes';
import { useAppStore } from '../store/app/appStore';
import { clearStore } from '../store/storeHelpers';
import { deletePersistedData } from '../store/tinybase/persister/helpers';

export const signIn = (loginRedirectUri?: string) =>
  window.open(apiRoutes.login(loginRedirectUri), '_self');

export const logout = async () => {
  const isLoggedInClient = () => !!useAppStore.getState().user;

  if (isLoggedInClient()) {
    await axios.get(apiRoutes.logout).catch(() => null);

    // Check logged in state again before clearing store (to avoid removing the redirect URL)
    // as this fn could be called multiple times in quick succession if several requests return a 401.
    // Clearing the store will trigger a redirect to /login (useEnsureHasRegisteredUser.ts)
    if (isLoggedInClient()) {
      clearStore();
    }
  } else {
    // Ensure any userStore data on the device is deleted (is also triggered via clearStore)
    await deletePersistedData('tinybase-user');
  }
};
